import type { PropsWithChildren, ReactElement } from 'react';
import { InspectionChartRuntimeProvider } from './inspection/InspectionChartRuntimeContext';
import { IssueChartRuntimeProvider } from './issue/IssueChartRuntimeContext';

export function AnalyticsChartRuntimeProvider({
  children,
}: PropsWithChildren<{}>): ReactElement {
  return (
    <IssueChartRuntimeProvider>
      <InspectionChartRuntimeProvider>
        {children}
      </InspectionChartRuntimeProvider>
    </IssueChartRuntimeProvider>
  );
}
